<div class="side-line">
  <div class="text-div">
    <b>{{text() ?? "Upload image (optional)"}}</b>
    <br>
      <span class="gray-text">Files must be under 64 MB, Files accepted: bmp, tiff, png, jpeg, jpg, gif,
      x-ms-bmp</span>
    </div>
    <div class="image-upload" [class.dragHover]="dropZoneHovered" (dragover)="dropZoneHovered = true"
      (dragleave)="dropZoneHovered = false">
      <input type="file" #fileDropRef class="fileDropRef" multiple (change)="onFileSelected($event)" aria-label="File Upload">
      Drop file(s) to upload or
      <button class="usa-button usa-button--secondary" for="fileDropRef">Select File(s)</button>
    </div>
    @if (thumbnails.length > 0) {
      <div class="text-div">
        <b>Images</b>
        @for (thumbnail of thumbnails; track thumbnail) {
          <div class="image-container">
            <div style="display: flex; position: relative;">
              @if (thumbnail.image) {
                <div class="thumbnail-container">
                  <img class="thumbnail" [src]="thumbnail.image" alt="user1">
                </div>
              }
              <div class="thumbnail-form">
                <b>{{ thumbnail.name }}</b>
                <br>
                  <span class="gray-text">{{ thumbnail.extension }} • {{ thumbnail.size | byte }}</span>
                  <br>
                    @if (thumbnail.progress !== undefined) {
                      <div class="progress-div">
                        <div class="progress-bg">
                          <div class="progress-front" [style]="'width: '+ thumbnail.progress*100 +'%'">
                          </div>
                        </div>
                      </div>
                    }
                    @if (thumbnail.image) {
                      <div>
                        <br>
                          <b>Image Caption</b>
                          <br>
                            <mat-form-field appearance="outline" class="caption-field">
                              <textarea matInput [formControl]="thumbnail.control" placeholder="Enter Image description" cdkTextareaAutosize
                                (change)="onCaptionUpdate(thumbnail.control)"
                              cdkAutosizeMinRows="2"></textarea>
                            </mat-form-field>
                            @if (thumbnail.control.value == '') {
                              <span class="gray-text">150 characters allowed</span>
                            }
                            @if (thumbnail.control.value != '') {
                              <span class="gray-text">{{ 150-thumbnail.control.value.length }} characters remaining</span>
                            }
                          </div>
                        }
                      </div>
                      <button class="delete-div" (click)="delete(thumbnail)">
                        <fa-icon [icon]="faCircleXmark" class="fa-regular fa-circle-mark delete-icon"
                        aria-label="close" matTooltipClass="tooltipClass" [matTooltip]="thumbnail.image ? 'Remove' : 'Cancel'"></fa-icon>
                      </button>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
